"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = exports.getDisplayName = exports["default"] = exports.connectPropertiesShape = exports.addWorkspaceEvents = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));

var _widgets = require("./widgets.actions");

var _excluded = ["connectProperties"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propertiesShape = _propTypes["default"].shape({
  assetId: _propTypes["default"].number,
  boxdatumId: _propTypes["default"].string,
  boxdataIds: _propTypes["default"].arrayOf(_propTypes["default"].string),
  startDate: _propTypes["default"].string,
  endDate: _propTypes["default"].string,
  tourId: _propTypes["default"].string,
  poiId: _propTypes["default"].number
});

var connectPropertiesShape = _propTypes["default"].shape({
  // merged properties from with values from incoming/outgoing
  assetId: _propTypes["default"].number,
  boxdatumId: _propTypes["default"].string,
  boxdataIds: _propTypes["default"].arrayOf(_propTypes["default"].string),
  startDate: _propTypes["default"].string,
  endDate: _propTypes["default"].string,
  tourId: _propTypes["default"].string,
  poiId: _propTypes["default"].number,
  // properties split up
  incoming: propertiesShape,
  outgoing: propertiesShape
}); // This method returns the display name of the original wrapped component (used for debug output)


exports.connectPropertiesShape = connectPropertiesShape;

var getDisplayName = function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

exports.getDisplayName = getDisplayName;

var addWorkspaceEvents = function addWorkspaceEvents() {
  return function (WrappedComponent) {
    var WorkspaceEvents = function WorkspaceEvents(_ref) {
      var connectProperties = _ref.connectProperties,
          otherProps = _objectWithoutProperties(_ref, _excluded);

      var dispatch = otherProps.dispatch,
          id = otherProps.id;
      /**
       * @deprecated
       */

      var selectAsset = (0, _react.useCallback)(function (assetId) {
        dispatch((0, _widgets.emitConnectEvent)(id, {
          assetId: assetId
        }));
      }, [dispatch, id]);
      /**
       * @deprecated
       */

      var selectBoxdata = (0, _react.useCallback)(function (boxdataIds) {
        dispatch((0, _widgets.emitConnectEvent)(id, {
          boxdataIds: boxdataIds
        }));
      }, [dispatch, id]);
      /**
       * @deprecated
       */

      var selectBoxdatum = (0, _react.useCallback)(function (boxdatumId) {
        dispatch((0, _widgets.emitConnectEvent)(id, {
          boxdatumId: boxdatumId
        }));
      }, [dispatch, id]);
      var handleEmitConnectEvent = (0, _react.useCallback)(function (propertiesToEmit) {
        dispatch((0, _widgets.emitConnectEvent)(id, propertiesToEmit));
      }, [dispatch, id]);
      var assetId = connectProperties.assetId,
          boxdatumId = connectProperties.boxdatumId,
          boxdataIds = connectProperties.boxdataIds;
      var eventProps = {
        emitConnectEvent: handleEmitConnectEvent,
        connectProperties: connectProperties,
        // deprecated methods
        selectedAsset: assetId,
        selectedBoxdatum: boxdatumId,
        selectedBoxdata: boxdataIds,
        selectAsset: selectAsset,
        selectBoxdatum: selectBoxdatum,
        selectBoxdata: selectBoxdata
      };
      return /*#__PURE__*/_react["default"].createElement(WrappedComponent, _extends({}, eventProps, otherProps));
    };

    WorkspaceEvents.displayName = "withWorkspaceEvents(".concat(getDisplayName(WrappedComponent), ")");
    WorkspaceEvents.propTypes = {
      dispatch: _propTypes["default"].func,
      id: _propTypes["default"].number.isRequired,
      connectProperties: connectPropertiesShape
    };

    var noop = function noop() {};

    WorkspaceEvents.defaultProps = {
      dispatch: noop,
      connectProperties: {
        incoming: {},
        outgoing: {}
      }
    };
    (0, _hoistNonReactStatics["default"])(WorkspaceEvents, WrappedComponent);
    return WorkspaceEvents;
  };
};

exports.addWorkspaceEvents = addWorkspaceEvents;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var widget = state.widgets[ownProps.id];
  var connected = widget.connected,
      connectProperties = widget.connectProperties;
  return {
    connected: connected,
    connectProperties: connectProperties
  };
};

exports.mapStateToProps = mapStateToProps;

var _default = function _default() {
  return function (Comp) {
    return (0, _reactRedux.connect)(mapStateToProps)(addWorkspaceEvents()(Comp));
  };
};

exports["default"] = _default;